import React from 'react';
import { useGlobalContext } from '../../../store/global';
import { sendSuggestion } from '../../../utils/data';
import { useTranslation } from 'react-i18next';

export default function Suggestion() {
  const { t } = useTranslation();
  const { closeModal, openModal } = useGlobalContext();

  const handleSubit = (e) => {
    e.preventDefault();
    const field = document.getElementById('suggestionbox');
    if (field.value) {
      sendSuggestion(field.value);
      openModal('thanks');
    }
  };

  return (
    <div className="popup-inner">
      <div className="popup-title">
        <h2>{t("suggestion_title")}</h2>
        <div className="close icon-x" onClick={closeModal}></div>
      </div>

      <div className="popup-content">
        <form action="">
          <div className="form-item">
            <label htmlFor="">{t("suggestion_label")}</label>
            <textarea
              name=""
              id="suggestionbox"
              cols="30"
              rows="4"
              maxLength={500}
              placeholder={t("suggestion_placeholder")}
              style={{ marginTop: '5px' }}
            />
          </div>
          <div className="form-actions">
            <button className="primary big" onClick={handleSubit}>
              {t("suggestion_submit")}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
